export const initCategoryMenu = () => {
    // event pro expand jednotlivych kategorii
    document.querySelectorAll('.category-menu .sublink-expand').forEach(expandButton => {
        expandButton.addEventListener('click', (e) => {
            const childrenEl = e.target.closest('.category-item').querySelector('.category-children');
            if (childrenEl == null) return;

            e.target.classList.toggle('expanded')
            childrenEl.classList.toggle('expanded');
        })
    });

    // event pro expand all
    const expandAllButtons = document.querySelectorAll('.category-menu .expand-all');
    expandAllButtons.forEach(expandAllButton => {
        expandAllButton.addEventListener('click', (e) => {
            document.querySelectorAll('.category-menu .category-children, .category-menu .sublink-expand').forEach(el => {
                el.classList.add('expanded');
            });
        })
    });

    // event pro collapse all
    const collapseAllButtons = document.querySelectorAll('.category-menu .collapse-all');
    collapseAllButtons.forEach(collapseAllButton => {
        collapseAllButton.addEventListener('click', (e) => {
            document.querySelectorAll('.category-menu .category-children, .category-menu .sublink-expand').forEach(el => {
                el.classList.remove('expanded');
            });
        })
    });
}